import { storeActions } from '@/store/actions'
import { createReducer, UnknownAction } from '@reduxjs/toolkit/react'

export type FeedbackState = {
  sendingStatus: 'idle' | 'sending' | 'failed' | 'sent'
  open: boolean
  messageId: string
}

export const feedbackInitialState: FeedbackState = {
  sendingStatus: 'idle',
  messageId: '',
  open: false,
}

export const feedbackReducer: ((
  state: FeedbackState | undefined,
  action: UnknownAction,
) => FeedbackState) & {
  getInitialState: () => FeedbackState
} = createReducer(feedbackInitialState, (builder) => {
  builder
    .addCase(storeActions.sendFeedback.pending, (state) => {
      state.sendingStatus = 'sending'
    })
    .addCase(storeActions.sendFeedback.fulfilled, (state) => {
      state.sendingStatus = 'sent'
    })
    .addCase(storeActions.sendFeedback.rejected, (state) => {
      state.sendingStatus = 'failed'
    })
    .addCase(storeActions.openFeedback, (state, { payload: { messageId } }) => {
      state.open = true
      state.messageId = messageId
      state.sendingStatus = feedbackInitialState.sendingStatus
    })
    .addCase(storeActions.closeFeedback, (state) => {
      state.open = false
      state.messageId = feedbackInitialState.messageId
      state.sendingStatus = feedbackInitialState.sendingStatus
    })
})
